<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Detail">
        <dpi-recommendation-detail></dpi-recommendation-detail>
    </mat-tab>
    <mat-tab label="Photos">
        <ng-template mat-tab-label>
            <span matBadge="{{pictureNum}}" [matBadgeHidden]="pictureNum === 0" matBadgeOverlap="false" class="tab_recommendation_badge">Photos</span>
        </ng-template>
        <dpi-recommendation-picture (listSizeChanged)="setPictureNum($event)"></dpi-recommendation-picture>
    </mat-tab>
</mat-tab-group>
